import DiagramWithToggleKey from "../shared/DiagramWithToggleKey";
import CardiometabolicCircadianRhythmCombined from "./index";

const CardiometabolicCircadianRhythmWithToggleKey = props => (
  <DiagramWithToggleKey
    CombinedDiagram={CardiometabolicCircadianRhythmCombined}
    keyControlsId="circadian-rhythm-key"
    {...props}
  />
);

export default CardiometabolicCircadianRhythmWithToggleKey;
